module.exports = __webpack_public_path__ + "static/media/button-html-tag.89af747e.svg";